export const enum MachineStatusType {
    not_applicable = "not_applicable",
    stopped = "stopped",
    running = "running"
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/MachineStatusType.tsx